import Snap from 'snapsvg-cjs';
import createTriangle from './create-triangle';
import createDots from './create-dots';

const mainAnimation = () => {
  const s = Snap('.c-hero__graph');
  if (s) {
    if (navigator.userAgent.indexOf('Chrome-Lighthouse') < 0) {
      var doc = Snap(document.width, document.height).attr({
        class: 'c-hero__triangles',
      });
    }
    const anim = mina.linear;
    const animEIO = mina.easeinout;
    // s.path('m0,798 l1915,0 l0,0 l-0,0 l-0,0 l-0,0 l-0,0 l0,0 l-1915,0 l-0,0z');
    const path = s
      .path('m0,798 l1915,0 l0,0 l-0,0 l-0,0 l-0,0 l-0,0 l0,0 l-1915,0 l-0,0z')
      .attr({
        stroke: '#203BAE',
        // stroke: '#fff',
        'stroke-width': 4,
        fill: '#171717',
      });
    const len = path.getTotalLength();
    let mainDot = null;
    let subDot = null;
    let dotLine = null;
    const dots = [];

    // matrix(-0.766,-0.6428,0.6428,-0.766,1846.7053,592.6758)
    const mainDotAnimation = () => {
      dotLine = s.line(1386, 232, 1386, 232);
      dotLine.attr({
        stroke: '#fff',
        strokeWidth: '2px',
      });
      subDot = s.circle(1386, 232, 3).attr({
        strokeWidth: '2px',
        stroke: '#fff',
        fill: 'transparent',
      });
      mainDot = s
        .circle(1386, 232, 1)
        .attr({
          fill: '#fff',
        })
        .animate({
            r: '5',
          },
          500,
          animEIO,
        );
      mainDot.animate({
          fill: '#9D7CFF',
          r: '10',
        },
        500,
        anim,
        () => {
          dots[6][5].animate({
              fill: '#9D7CFF',
              fillOpacity: 1,
              r: '5',
            },
            350,
            anim,
            () => {
              dots[6][6].animate({
                  fill: '#9D7CFF',
                  fillOpacity: 1,
                  r: '5',
                },
                350,
                anim,
                () => {
                  dots[6][7].animate({
                      fill: '#9D7CFF',
                      fillOpacity: 1,
                      r: '5',
                    },
                    350,
                    anim,
                  );
                },
              );
            },
          );
          subDot.animate({
              r: '150',
            },
            500,
            anim,
            () => {
              dotLine.animate({
                  x1: '1000',
                },
                500,
                animEIO,
                () => {
                  if (navigator.userAgent.indexOf('Chrome-Lighthouse') < 0) {
                    createTriangle(doc, 100, 330, 1050, 175, 40);
                    createTriangle(doc, 200, 310, 1050, 660, 50);
                    createTriangle(doc, 80, 230, 1600, 600, 20);
                    createTriangle(doc, 250, 220, 1700, 300, 80);
                  }
                },
              );
            },
          );
        },
      );
    };

    const drawLine = () => {
      path.animate({
          'stroke-dashoffset': 4948,
        },
        2500,
        anim,
      );
      setTimeout(() => {
        s.circle(560, 749, 1)
          .attr({
            fill: '#fff',
          })
          .animate({
              r: '5',
            },
            500,
            animEIO,
          );
      }, 650);
      setTimeout(() => {
        s.circle(985, 635, 1)
          .attr({
            fill: '#fff',
          })
          .animate({
              r: '5',
            },
            500,
            animEIO,
          );
      }, 1100);
      setTimeout(() => {
        s.circle(1225, 475, 1)
          .attr({
            fill: '#fff',
          })
          .animate({
              r: '5',
            },
            500,
            animEIO,
          );
      }, 1500);
      setTimeout(() => {
        mainDotAnimation();
      }, 2250);
      setTimeout(() => {
        s.circle(1705, 75, 1)
          .attr({
            fill: '#fff',
          })
          .animate({
              r: '5',
            },
            500,
            animEIO,
          );
      }, 2250);
    };

    path.attr({
      'stroke-dasharray': `${len} ${len}`,
      'stroke-dashoffset': 2767,
    });
    path.animate({
        d: 'm0,798 l1915,0 l0,-24 l-0,0 l-0,0 l-0,0 l-0,0 l0,0 l-1915,24 l-0,0z',
      },
      300,
      anim,
      () => {
        path.animate({
            // d: 'm0,798 l1915,0 l0,-121 l-0,0 l-0,0 l-0,0 l-0,0 l-1355,77 l-560,44 l-0,0z',
            d: 'm0,798 l1915,0 l0,-165 l-0,0 l-0,0 l-0,0 l-0,0 l-1355,117 l-560,48 l-0,0z',
          },
          400,
          anim,
          () => {
            path.animate({
                // d: 'm0,798 l1915,0 l0,-300 l-0,0 l-0,0 l-0,0 l-949,179 l-406,77 l-560,44 l-0,0z',
                d: 'm0,798 l1915,0 l0,-325 l-0,0 l-0,0 l-0,0 l-929,160 l-426,117 l-560,48 l-0,0z',
              },
              400,
              anim,
              () => {
                drawLine();
                path.animate({
                    // d: 'm0,798 l1915,0 l0,-559 l-0,0 l-0,0 l-681,259 l-268,179 l-406,77 l-560,44 l-0,0z',
                    d: 'm0,798 l1915,0 l0,-564 l-0,0 l-0,0 l-691,239 l-238,160 l-426,117 l-560,48 l-0,0z',
                  },
                  400,
                  anim,
                  () => {
                    if (navigator.userAgent.indexOf('Chrome-Lighthouse') < 0) {
                      createDots(doc, 17, 13, 902, 145, animEIO, dots);
                      createDots(doc, 17, 13, -1050, 1347);
                    }
                    path.animate({
                        // d: 'm0,798 l1915,0 l0,-730 l-0,0 l-530,171 l-151,259 l-268,179 l-406,77 l-560,44 l-0,0z',
                        d: 'm0,798 l1915,0 l0,-725 l-0,0 l-540,161 l-161,239 l-238,160 l-426,117 l-560,48 l-0,0z',
                      },
                      700,
                      anim,
                      () => {
                        path.animate({
                            // d: 'm0,798 l1915,0 l0,-798 l-210,73 l-320,161 l-151,259 l-268,179 l-406,77 l-560,44 l-0,0z',
                            d: 'm0,798 l1915,0 l0,-798 l-210,73 l-320,161 l-161,239 l-238,160 l-426,117 l-560,48 l-0,0z',
                          },
                          700,
                          anim,
                        );
                      },
                    );
                  },
                );
              },
            );
          },
        );
      },
    );
  }
};

export default mainAnimation;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/kerris-select-chisel/src/scripts/modules/main-animation.js